import { buildPlayButtonIcon } from './play-button-icon.js';

/*
  Builds the animated play-button icon inside every `<span class="cvp">`
  placeholder. Drop `<span class="cvp"></span>` into an Elementor HTML widget
  to get the icon; no other Elementor setup needed.
*/

var started = false;

function scan(root) {
    root = root || document;

    root.querySelectorAll('.cvp').forEach(function (el) {
        if (el.querySelector('.cvp-btn')) {
            return;
        }

        el.appendChild(buildPlayButtonIcon('cvp'));
    });
}

export function initCustomVideoPlayButton() {
    scan();

    if (started) {
        return;
    }

    started = true;

    /*
      Covers `.cvp` placeholders inserted after this ran, e.g. inside an
      Elementor popup that only gets added to the DOM when it opens.
    */
    var observer = new MutationObserver(function () {
        scan();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}
